/**
 * Fleetio vehicle status names the exchange journey needs to recognise by name.
 *
 * These MUST match the constants of the same names in `src/py/adapters/fleetio_constants.py`. They are duplicated here
 * because the journey pre-selects a status in a dropdown, which is a client side decision.
 *
 * A mismatch degrades safely rather than doing the wrong thing: nothing pre-selects, and the CSR
 * picks the status themselves - the behaviour for every exchange before DAMS existed. It never
 * causes the wrong status to be chosen.
 *
 * The two DAMS names are confirmed against the GB Fleetio instances.
 */
export const DAMS_CONTRACTED_AWAITING_REPAIR_STATUS = "Depot - Accident (DAMS)";
export const DAMS_CROSS_HIRE_ACTIVE_STATUS = "Active - DAMS Cross Hire";
export const DAMS_CONTRACTED_OFFROAD_STATUS = "Off Road / Site - Smash Repair (DAMS)";
export const DEPOT_AVAILABLE_STATUS = "Depot - Available";
